import * as React from "react"
import type { SVGProps } from "react"
const SvgBarChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.62 19.78q.3.3.71.3.43 0 .72-.3a1 1 0 0 0 .28-.7v-12a1 1 0 0 0-.28-.72 1 1 0 0 0-.72-.29 1 1 0 0 0-.7.29 1 1 0 0 0-.3.71v12q0 .42.3.71m11.38.3a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7v-13q0-.44.29-.72a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v13q0 .42-.29.71a1 1 0 0 1-.71.29Zm-5.33 0a1 1 0 0 1-.72-.3 1 1 0 0 1-.28-.7v-8q0-.44.28-.72a1 1 0 0 1 .72-.29q.42 0 .7.29.3.3.3.71v8q0 .43-.3.71a1 1 0 0 1-.7.3M4 20.07a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.71v-7q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v7q0 .42-.29.71a1 1 0 0 1-.71.29Z" />
  </svg>
)
export default SvgBarChart
